module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Smart_Lights.3319a2a6.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Smart_Lights.svg
// module id = 1605
// module chunks = 0